import { Pipe, PipeTransform, inject } from '@angular/core';
import { LocalizationService } from '../../core/localization/localization.service';

@Pipe({
  name: 'ainAmount',
  standalone: true
})
export class AinAmountPipe implements PipeTransform {
  private readonly localization = inject(LocalizationService);

  transform(value: number | string | null | undefined, fractionDigits = 0): string {
    const normalized = typeof value === 'string' ? Number(value) : value;
    if (normalized === null || normalized === undefined || !Number.isFinite(normalized)) {
      return '-';
    }

    const culture = this.localization.activeCulture();
    return new Intl.NumberFormat(culture, {
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: 0
    }).format(normalized);
  }
}
